import React from 'react';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { Controller, useFormContext } from 'react-hook-form-legacy';
import {
  SelectSingle,
  Props as SelectSingleProps,
} from '../../../apps/dashboard/components/Selects/SelectSingle';
import InputError from '../InputError';
import { getError } from '../utils';

type Props = Omit<SelectSingleProps, 'value' | 'onChange'> & {
  name: string;
};

export const SelectSingleControlled: React.FC<
  React.PropsWithChildren<Props>
> = ({ name, ...props }) => {
  const { control, errors } = useFormContext();

  const error = getError(name, errors);

  return (
    <>
      <Controller
        as={({ value, onChange }) => {
          return (
            <SelectSingle
              {...props}
              value={value}
              onChange={onChange}
              error={error !== undefined}
              className={error ? 'is-invalid' : ''}
            />
          );
        }}
        name={name}
        control={control}
      />
      <InputError error={error} />
    </>
  );
};
